import { CurationResponse } from '../../@types/response-mkm';
import instance from './instance';

export async function getCuration() {
  const response = await instance.get<CurationResponse>('/curation');

  return response.data;
}
